'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = registerInput;
function registerInput(cmp, input) {
  cmp.input = input;

  if (typeof cmp.props.registerInput === 'function') {
    cmp.props.registerInput(input);
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-input-enhancements/lib/utils/registerInput.js
// module id = 79
// module chunks = 0